import * as React from 'react'

function IconFile(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={74}
      height={74}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={74} height={74} rx={37} fill="#F4BA27" />
      <path
        d="M38.334 15.358h-9.231c-2.164 0-4.24.856-5.77 2.38a8.108 8.108 0 00-2.39 5.745v26.979c0 2.154.86 4.22 2.39 5.744a8.177 8.177 0 005.77 2.38h16.093c2.164 0 4.24-.856 5.77-2.38a8.107 8.107 0 002.39-5.745V30.344a8.095 8.095 0 00-2.39-5.745l-6.877-6.849a8.177 8.177 0 00-5.755-2.39v0z"
        stroke="#fff"
        strokeWidth={5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M36.83 15.383v10.654a5.186 5.186 0 001.553 3.69 5.342 5.342 0 003.745 1.53h9.306"
        stroke="#fff"
        strokeWidth={5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconFile
